import type { ComposedForm } from 'lib-node-question-builder';

import { READONLY_CONDITION } from '~/pages/Loan1003DataGrids/common/utils/utils';

import type { BorrowerData, BorrowerDropdownOptions } from '../../../types';

type PowerOfAttorneyProps = {
  form: ComposedForm<BorrowerData['formData']>;
  dropdownOptions: BorrowerDropdownOptions;
};

export function PowerOfAttorney({
  form,
  dropdownOptions,
}: Readonly<PowerOfAttorneyProps>) {
  return (
    <form.Subscribe selector={(s) => !s.values.powerOfAttorneySigners?.length}>
      {(showAddButton) => (
        <form.FieldArray
          name="powerOfAttorneySigners"
          label=""
          enableAdd={showAddButton}
          template={[
            {
              elementType: 'component',
              type: 'grid',
              style: { padding: '0 0.5rem' },
              name: '',
              columns: 7,
              fields: [
                {
                  elementType: 'question',
                  type: 'text',
                  name: 'powerOfAttorneySigners[{i}].signer',
                  label: 'Signer',
                  span: 3,
                  rules: {
                    required: true,
                  },
                  conditions: {
                    isDisabled: READONLY_CONDITION,
                  },
                },
                {
                  elementType: 'question',
                  type: 'select',
                  name: 'powerOfAttorneySigners[{i}].mannerPowerOfAttorneyHeld',
                  label: 'Manner POA Held',
                  options: dropdownOptions.mannerPowerOfAttorneyHeld,
                  placeholder: 'Select Option',
                  span: 3,
                  conditions: {
                    isDisabled: READONLY_CONDITION,
                  },
                },
                {
                  elementType: 'component',
                  type: 'fieldArrayDeleteButton',
                  name: 'deleteSignerButton',
                  value: '{i}',
                  conditions: {
                    isDisabled: READONLY_CONDITION,
                  },
                },
              ],
            },
          ]}
          addButtonLabel="Add Signer"
          restrictions={{
            max: 1,
          }}
        />
      )}
    </form.Subscribe>
  );
}
